import { useContext } from "react";
import { UserContext } from "../context/UserContext";
import { MUTATE_ANALYTICS } from "../graphql/queries";
import { client } from "../index";

const useMutateAnalytics = () => {
	const { user } = useContext(UserContext);

	const mutateAnalytics = (data) => {
		if (user?.currentOrganizationRole === "SuperAdmin") {
			return;
		}
		client.mutate({
			mutation: MUTATE_ANALYTICS,
			variables: {
				...data,
			},
		});
	};
	return mutateAnalytics;
};

export default useMutateAnalytics;
